<script lang="ts">
	//Services
	import { format } from '../../../../../services/i18n';
	//Helpers
	import { formatSnakeCaseToTitle } from '../../../../../helpers/utilities';
	//Design system components
	import { Container, Radio, Text } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import SettingGuide from '../../../SettingGuide.svelte';
	//Types
	import type { InputOutputOptions } from './input_output_types';

	export let typeValue: string, modeValue: string, buttonModeOptions: InputOutputOptions;

	const setButtonMode = async (_modeValue) => {
		modeValue = _modeValue;
	};

	const isOptionUnavailable = (option: InputOutputOptions[string]) =>
		option.type !== typeValue && option.type !== 'any';

	$: {
		const selected = buttonModeOptions[modeValue];
		if (selected && isOptionUnavailable(selected)) {
			const firstAvailable = Object.entries(buttonModeOptions).find(
				([, option]) => !isOptionUnavailable(option),
			);
			if (firstAvailable) {
				modeValue = firstAvailable[0];
			}
		}
	}
</script>

{#if $showNewLayout}
	<div>
		<Text class="text-bold mb-xs">
			{formatSnakeCaseToTitle($format('output_type_label', { default: 'Set output type' }))}
		</Text>
		<SettingGuide
			text={$format('settings_guide_output_type', {
				default:
					'Choose how the physical switch or button drives the output — toggle, dimming, detached, or activation.',
			})}
		/>
		{#each Object.entries(buttonModeOptions) as option (option[0])}
			{#if !isOptionUnavailable(option[1])}
				<Radio
					size="m"
					bind:selected={modeValue}
					value={option[0]}
					class="mb-xs"
					on:click={() => setButtonMode(option[0])}
					id={`radio-output-mode-${option[0]}`}
					info={option[1]?.description}
				>
					{option[1]?.title}
				</Radio>
			{/if}
		{/each}
	</div>
{:else}
	<Container type="base" class="mb-s" padding="xs">
		<Text class="text-bold mb-s">
			{formatSnakeCaseToTitle($format('output_type_label', { default: 'Set output type' }))}
		</Text>
		{#each Object.entries(buttonModeOptions) as option (option[0])}
			<Radio
				size="m"
				bind:selected={modeValue}
				value={option[0]}
				class="mb-s"
				disabled={isOptionUnavailable(option[1])}
				on:click={() => setButtonMode(option[0])}
				id="radio-wbi4xig"
			>
				{option[1].text}
			</Radio>
		{/each}
	</Container>
{/if}
